import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
//elementUI
import ElementPlus from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import "./assets/css/element-variables.scss";
//公共方法
import dataConver from "@/utils/convertData.js";
//时间处理
import moment from "moment";
//axios
import request from "@/utils/request";
//剪切
import VueClipboard from "vue-clipboard2";
//省市区
import fullCitys from "@/utils/full-citys";
//注册element图标组件
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
//注册全局方法
app.config.globalProperties.$dataConver = dataConver;
app.config.globalProperties.$http = request;
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$fullCitys = fullCitys;
//渲染
app
  .use(store)
  .use(router)
  .use(VueClipboard)
  .use(ElementPlus, { locale: zhCn })
  .mount("#app");
//自定义指令
app.directive("grantShow", (el, binding) => {
  let grants = store.state.userInfo.grants || "*";
  if (el.parentNode && !dataConver.checkGrants(grants, binding.value)) {
    el.parentNode.removeChild(el);
  }
});
